import { render, staticRenderFns } from "./lrTime.vue?vue&type=template&id=21ca0580&"
import script from "./lrTime.vue?vue&type=script&lang=js&"
export * from "./lrTime.vue?vue&type=script&lang=js&"
import style0 from "./lrTime.vue?vue&type=style&index=0&id=21ca0580&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports